// Bouton version + bannière de mise à jour + changelog.
//
// Pourquoi une BANNIÈRE et pas un rechargement silencieux : l'app contient
// désormais un formulaire de note de frais. Recharger dans le dos de
// l'utilisateur effacerait une saisie en cours. On détecte en fond, on propose
// en un tap — non destructif.
//
// Le bouton sert aussi de roue de secours : si la détection automatique échoue
// (cache agressif, PWA iOS), un tap force la mise à jour.

import { APP_VERSION, verifierVersion, forcerMiseAJour } from "../lib/version.js";
import { CHANGELOG } from "../lib/changelog.js";

const el = (tag, cls, texte) => {
  const n = document.createElement(tag);
  if (cls) n.className = cls;
  if (texte != null) n.textContent = texte;
  return n;
};

let banniereAffichee = false;

/** Bannière « une nouvelle version est disponible » — un tap, non destructif. */
function afficherBanniere() {
  if (banniereAffichee || document.getElementById("maj-banniere")) return;
  banniereAffichee = true;

  const b = el("div", "maj-banniere");
  b.id = "maj-banniere";
  b.appendChild(el("span", null, "Une nouvelle version est disponible."));

  const oui = el("button", "btn-primary", "Mettre à jour");
  oui.type = "button";
  oui.addEventListener("click", () => {
    oui.disabled = true;
    oui.textContent = "Mise à jour…";
    forcerMiseAJour();
  });
  b.appendChild(oui);

  const plusTard = el("button", "btn-mini", "Plus tard");
  plusTard.type = "button";
  // « Plus tard » ne doit pas être un piège : la vérification continue, la
  // bannière reviendra au prochain retour sur l'app.
  plusTard.addEventListener("click", () => {
    b.remove();
    banniereAffichee = false;
  });
  b.appendChild(plusTard);

  document.body.appendChild(b);
}

/** Modale du changelog. */
function ouvrirChangelog() {
  const fond = el("div", "modale-fond");
  fond.addEventListener("click", (e) => {
    if (e.target === fond) fond.remove();
  });

  const boite = el("div", "modale");
  const tete = el("div", "modale-tete");
  tete.appendChild(el("h2", null, "Nouveautés"));
  const fermer = el("button", "btn-mini", "Fermer");
  fermer.type = "button";
  fermer.addEventListener("click", () => fond.remove());
  tete.appendChild(fermer);
  boite.appendChild(tete);

  for (const entree of CHANGELOG) {
    const bloc = el("div", "chl-entree");
    const enTete = el("div", "chl-tete");
    enTete.appendChild(el("span", "chl-version", "v" + entree.version));
    enTete.appendChild(el("span", "chl-date", entree.date));
    bloc.appendChild(enTete);
    bloc.appendChild(el("div", "chl-titre", entree.title));
    const ul = document.createElement("ul");
    for (const item of entree.items) ul.appendChild(el("li", null, item));
    bloc.appendChild(ul);
    boite.appendChild(bloc);
  }

  const pied = el("div", "chl-pied");
  const forcer = el("button", "btn-mini", "Forcer la mise à jour");
  forcer.type = "button";
  forcer.addEventListener("click", () => {
    forcer.disabled = true;
    forcer.textContent = "Mise à jour…";
    forcerMiseAJour();
  });
  pied.appendChild(forcer);
  boite.appendChild(pied);

  fond.appendChild(boite);
  document.body.appendChild(fond);
}

/**
 * Monte le chip de version dans l'en-tête et démarre la surveillance.
 * Vérifie au montage, au retour sur l'app, au focus, et toutes les 5 minutes —
 * c'est le retour sur l'app qui compte le plus pour une PWA, qu'on rouvre
 * souvent sans jamais la recharger.
 */
export function monterBoutonVersion(hote) {
  if (!hote) return;

  const chip = el("button", "chip-version", "v" + APP_VERSION);
  chip.type = "button";
  chip.title = "Voir les nouveautés et forcer la mise à jour";
  chip.addEventListener("click", ouvrirChangelog);
  hote.appendChild(chip);

  const controler = async () => {
    const { disponible } = await verifierVersion();
    if (disponible) {
      chip.classList.add("chip-maj");
      chip.title = "Une nouvelle version est disponible";
      afficherBanniere();
    }
  };

  controler();
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) controler();
  });
  window.addEventListener("focus", controler);
  setInterval(controler, 5 * 60 * 1000);
}
